<div class="section">
  <div class="section__header">
    <h2 class="section__header-text">Venue/Location <mat-icon (click)="openEditLocationDialog()" *ngIf="editModeSet" class="edit-icon">edit</mat-icon></h2>
  </div>
  <div class="section__body">
    <div class="section__content event__content">
      <div class='event-location-row'>
        <div class='event-location-column'>
          <div class="event-location-header">
            Event Format:
          </div>
          <div style="padding-bottom: 7px;">
            {{ aviationEvent.format }}
          </div>
          <ng-container  *ngIf="aviationEvent.format === 'In-Person' || aviationEvent.format === 'Both'">
            <div class='event-location-header'>
              Venue/Location:
            </div>
            <div style="padding-bottom: 7px;" *ngIf="aviationEvent.venueLocationName">
              {{ aviationEvent.venueLocationName }}
            </div>
            <div class='event-location-header' *ngIf="aviationEvent.address1">
              Address:
            </div>
            <div *ngIf="aviationEvent.address1">
              {{ aviationEvent.address1 }}
            </div>
            <div *ngIf="aviationEvent.address2">
              {{ aviationEvent.address2 }}
            </div>
            <div *ngIf="aviationEvent.address3">
              {{ aviationEvent.address3 }}
            </div>
            <div *ngIf="aviationEvent.city && aviationEvent.stateProvince">
              {{ aviationEvent.city }}, {{ aviationEvent.stateProvince }} <ng-container *ngIf="aviationEvent.zipcode">{{ aviationEvent.zipcode }}</ng-container>
            </div>
            <div *ngIf="aviationEvent.country && aviationEvent.country !== 'United States'">
              {{ aviationEvent.country }}
            </div>
          </ng-container>

        </div>
        <div *ngIf="aviationEvent.airportId" class='event-location-column'>
          <div class='event-location-header'>
            Airport:
          </div>
          <div>
            ({{ aviationEvent.airportIdent }}) {{ aviationEvent.airportName }} <a [routerLink]="['/airports', aviationEvent.airportIdent]" target="_blank">(Airport Details)</a>
          </div>
          <div style="padding-bottom: 7px;">
            {{ aviationEvent.airportCity }}, {{ aviationEvent.airportState }}
          </div>
          <div *ngIf="aviationEvent.airportLongestRunway">
            Longest Runway: {{ aviationEvent.airportLongestRunway }}
          </div>
          <div *ngIf="aviationEvent.airportFuelTypes && aviationEvent.airportFuelTypes.length > 0">
            Fuel Available: {{ airportFuelTypesWithCommas }}
          </div>
        </div>
        <div *ngIf="aviationEvent.internationalAirportId" class='event-location-column'>
          <div class='event-location-header'>
            Airport:
          </div>
          <div>
            ({{ aviationEvent.internationalAirportId }}) {{ aviationEvent.internationalAirportName }}
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
